export const getCountryData = [
  "Please Select Country",
  "Afghanistan",
  "Africa",
  "Albania",
  "Algeria",
  "All",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua-and-Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Asia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia-and-Herzegovina",
  "Botswana",
  "Brazil",
  "British-Virgin-Islands",
  "Brunei",
  "Bulgaria",
  "Burkina-Faso",
  "Burundi",
  "CAR",
  "Cabo-Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Caribbean-Netherlands",
  "Cayman-Islands",
  "Chad",
  "Channel-Islands",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Cook-Islands",
  "Costa-Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czechia",
  "DPRK",
  "DRC",
  "Denmark",
  "Diamond-Princess",
  "Diamond-Princess-",
  "Djibouti",
  "Dominica",
  "Dominican-Republic",
  "Ecuador",
  "Egypt",
  "El-Salvador",
  "Equatorial-Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Europe",
  "Faeroe-Islands",
  "Falkland-Islands",
  "Fiji",
  "Finland",
  "France",
  "French-Guiana",
  "French-Polynesia",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong-Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle-of-Man",
  "Israel",
  "Italy",
  "Ivory-Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "MS-Zaandam",
  "MS-Zaandam-",
  "Macao",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall-Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New-Caledonia",
  "New-Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "North-America",
  "North-Macedonia",
  "Norway",
  "Oceania",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua-New-Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto-Rico",
  "Qatar",
  "Réunion",
  "Romania",
  "Russia",
  "Rwanda",
  "S-Korea",
  "Saint-Helena",
  "Saint-Kitts-and-Nevis",
  "Saint-Lucia",
  "Saint-Martin",
  "Saint-Pierre-Miquelon",
  "Samoa",
  "San-Marino",
  "Sao-Tome-and-Principe",
  "Saudi-Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra-Leone",
  "Singapore",
  "Sint-Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon-Islands",
  "Somalia",
  "South-Africa",
  "South-America",
  "South-Sudan",
  "Spain",
  "Sri-Lanka",
  "St-Barth",
  "St-Vincent-Grenadines",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad-and-Tobago",
  "Tunisia",
  "Turkey",
  "Turks-and-Caicos",
  "Tuvalu",
  "UAE",
  "UK",
  "US-Virgin-Islands",
  "USA",
  "Uganda",
  "Ukraine",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican-City",
  "Venezuela",
  "Vietnam",
  "Wallis-and-Futuna",
  "Western-Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];
